import React from 'react'

const Button = ({ children, ...otherProps}) => {
	return (
		<button className="btn btn-primary mx-3" {...otherProps}>
			{children}
		</button>
	)
}

export default Button
